import { render } from "./HotelSearchBar.vue?vue&type=template&id=9b2d437c&scoped=true"
import script from "./HotelSearchBar.vue?vue&type=script&lang=js"
export * from "./HotelSearchBar.vue?vue&type=script&lang=js"

import "./HotelSearchBar.vue?vue&type=style&index=0&id=9b2d437c&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b2d437c"]])

export default __exports__